import classNames from 'classnames'
import InfinitScroll from 'components/infinitScrol'
import DotsLoading from 'components/loadings/dotsLoading'
import { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import InfiniteScroll from 'react-infinite-scroll-component'
import { InfiniteData } from 'react-query'
import { TabList, Tabs, Tab, TabPanel } from 'react-tabs'
import useSetGuarantor from './hooks/useSetGuarantor'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'
interface IModalProps {
    show: boolean
    onHide: () => void
    users: InfiniteData<IGetMoneyPoolUsers> | undefined
    onWatchEnd: () => void
    refetch: () => void
    selectedUser: IMoneyPoolResults | undefined
}
export default function UserGuarantorModal({
    show,
    onHide,
    users,
    onWatchEnd,
    refetch,
    selectedUser,
}: IModalProps) {
    const { id } = useParams()
    const [selectedTab, setSelectedTab] = useState<number>(0)
    const [selectedGuarantor, setSelectedGuarantor] = useState<
        number | undefined
    >()
    const [recommended, setRecommended] = useState<number | undefined>()
    const { mutate } = useSetGuarantor(refetch)
    useEffect(() => {
        if (users && selectedUser) {
            const initGuarantor = users.pages
                .flatMap((x) => x.results)
                .find((item) => item.id === selectedUser.guarantor?.id)

            setSelectedGuarantor(initGuarantor?.id)
            const initRecommender = users.pages
                .flatMap((x) => x.results)
                .find((item) => item.id === selectedUser.recommender?.id)
            setRecommended(initRecommender?.id)
        }
    }, [users, selectedUser])
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full text-center py-4 text-sm px-4 h-[500px] overflow-y-scroll ">
                <Tabs defaultIndex={0}>
                    <TabList>
                        <p className=" mb-3">تعیین ضامن و معرف</p>
                        <hr />
                        <div className=" flex w-full justify-between text-center mt-2">
                            <Tab
                                className={classNames(
                                    'w-full py-2',
                                    selectedTab === 0 &&
                                        ' text-green-1 border-b border-green-1'
                                )}
                                onClick={() => setSelectedTab(0)}
                            >
                                ضامن
                            </Tab>
                            <Tab
                                className={classNames(
                                    'w-full py-2',
                                    selectedTab === 1 &&
                                        ' text-green-1 border-b border-green-1'
                                )}
                                onClick={() => setSelectedTab(1)}
                            >
                                معرف
                            </Tab>
                        </div>
                    </TabList>
                    <div className=" mt-4">
                        <TabPanel>
                            <InfiniteScroll
                                next={onWatchEnd}
                                hasMore={
                                    users
                                        ? users?.pages[users.pages.length - 1]
                                              .next
                                            ? true
                                            : false
                                        : false
                                }
                                dataLength={
                                    users
                                        ? users.pages.flatMap((x) => x.results)
                                              .length
                                        : 0
                                }
                                loader={<DotsLoading />}
                            >
                                <div>
                                    {users ? (
                                        <>
                                            {users.pages
                                                .flatMap((x) => x.results)
                                                .map((item) => (
                                                    <div key={item.id}>
                                                        <p
                                                            className={classNames(
                                                                ' my-2 py-1 rounded-full w-full',
                                                                selectedGuarantor ===
                                                                    item.id &&
                                                                    'border-1 border-green-1'
                                                            )}
                                                            onClick={() =>
                                                                setSelectedGuarantor(
                                                                    item.id
                                                                )
                                                            }
                                                        >
                                                            {
                                                                item.member
                                                                    .first_name
                                                            }{' '}
                                                            {
                                                                item.member
                                                                    .last_name
                                                            }
                                                        </p>
                                                    </div>
                                                ))}
                                        </>
                                    ) : (
                                        <DotsLoading />
                                    )}
                                </div>
                            </InfiniteScroll>
                        </TabPanel>
                        <TabPanel>
                            <InfiniteScroll
                                next={onWatchEnd}
                                hasMore={
                                    users
                                        ? users?.pages[users.pages.length - 1]
                                              .next
                                            ? true
                                            : false
                                        : false
                                }
                                dataLength={
                                    users
                                        ? users.pages.flatMap((x) => x.results)
                                              .length
                                        : 0
                                }
                                loader={<DotsLoading />}
                            >
                                <div>
                                    {users ? (
                                        <>
                                            {users.pages
                                                .flatMap((x) => x.results)
                                                .map((item) => (
                                                    <div key={item.id}>
                                                        <p
                                                            className={classNames(
                                                                ' my-2 py-1 rounded-full w-full',
                                                                recommended ===
                                                                    item.id &&
                                                                    'border-1 border-green-1'
                                                            )}
                                                            onClick={() =>
                                                                setRecommended(
                                                                    item.id
                                                                )
                                                            }
                                                        >
                                                            {
                                                                item.member
                                                                    .first_name
                                                            }{' '}
                                                            {
                                                                item.member
                                                                    .last_name
                                                            }
                                                        </p>
                                                    </div>
                                                ))}
                                        </>
                                    ) : (
                                        <DotsLoading />
                                    )}
                                </div>
                            </InfiniteScroll>
                        </TabPanel>
                    </div>
                </Tabs>
            </div>
            <hr />
            <p
                className=" text-center text-green-1  my-2"
                onClick={() => {
                    if (selectedUser) {
                        const payload: ISetGuarantorSettingPayload = {
                            moneyPool: id,
                            poolShip: selectedUser?.id,
                            role: selectedUser?.role,
                            share: selectedUser?.number_of_shares,
                            guarantor: selectedGuarantor,
                            recommender: recommended,
                        }
                        mutate(payload)
                        onHide()
                    }
                }}
            >
                تایید
            </p>
        </Modal>
    )
}
